import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BackgroundLayer from "../components/BackgroundLayer";
import BrandLogo from "../components/BrandLogo";
import { ChevronRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function SplashScreen() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [showButton, setShowButton] = useState(false);
  const [fadingOut, setFadingOut] = useState(false);

  // Reveal button after 800ms so the splash animation can play first
  useEffect(() => {
    const t = setTimeout(() => setShowButton(true), 800);
    return () => clearTimeout(t);
  }, []);

  const next = () => {
    setFadingOut(true);
    setTimeout(() => {
      if (user) {
        navigate("/home", { replace: true });
      } else {
        // Always show onboarding tour when user actively taps Get Started
        navigate("/onboarding", { replace: true });
      }
    }, 400);
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center relative px-6"
      style={{
        opacity: fadingOut ? 0 : 1,
        transition: "opacity 400ms ease-out",
      }}
      data-testid="splash-screen"
    >
      <BackgroundLayer section="splash" />

      <div className="text-center splash-content">
        <div
          className="splash-logo flex flex-col items-center justify-center"
          data-testid="splash-logo"
        >
          <BrandLogo width={300} />
        </div>

        <p
          className="splash-tagline"
          style={{
            fontSize: 13,
            color: "rgba(255,255,255,0.55)",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            marginTop: 18,
          }}
          data-testid="splash-tagline"
        >
          Your plants, understood.
        </p>
      </div>

      {/* Manual Get Started button + pulsing dot */}
      <div className="absolute bottom-12 left-0 right-0 flex flex-col items-center gap-4">
        {showButton ? (
          <button
            onClick={next}
            data-testid="splash-continue"
            className="btn-primary inline-flex items-center gap-2 fade-up"
            style={{ minWidth: 220, justifyContent: "center" }}
          >
            Get Started <ChevronRight size={18} />
          </button>
        ) : (
          <span
            className="splash-dot"
            style={{
              width: 8,
              height: 8,
              borderRadius: 999,
              background: "var(--accent-green)",
              boxShadow: "var(--glow-green)",
              display: "inline-block",
            }}
            data-testid="splash-loader"
          />
        )}
      </div>
    </div>
  );
}
